import { api } from './BaseService'

export const getBrands = async () => {
    return await api.get(`/brands`)
}

export const getBrandById = async (id) => {
    return await api.get(`/brands/${id}`)
}

export const createBrand = async (data) => {
    return await api.post(`/brands`, data)
}
export const updateBrand = async (data) => {
    return await api.put(`/brands/${data?.id}`, data)
}
export const deleteBrand = async (id) => {
    return await api.delete(`/brands/${id}`)
}
